module.exports = __webpack_public_path__ + "static/img/lQDPJxnyzCxQcP_155.a96a2420.jpg";